/** "15 minutes", "6 hours", "1 day": a schedule's interval as people say it. */
export function formatInterval(t: (key: string, vars?: Record<string, string | number>) => string, minutes: number): string {
  if (minutes % 1440 === 0) return t('work.interval.days', { count: minutes / 1440 })
  if (minutes % 60 === 0) return t('work.interval.hours', { count: minutes / 60 })
  return t('work.interval.minutes', { count: minutes })
}
